import { alias, list, object, serializable } from 'serializr';

export class SoilDetails {
  @serializable
  texture?: string;

  @serializable
  moisture?: string;

  @serializable(alias('organic_carbon_percentage'))
  organicCarbonPercentage?: number;

  @serializable(alias('organic_matter_percentage'))
  organicMatterPercentage?: number;
}

export class LandChanges {
  @serializable
  label?: string;

  @serializable
  from?: string;

  @serializable
  to?: string | null;

  @serializable(alias('year_changed'))
  yearChanged?: number;

  @serializable(alias('change_percentage'))
  changedPercentage?: number;
}

export class CropResidue {
  @serializable(alias('residue_management_type'))
  residueManagementType?: string;

  @serializable(alias('percentage_of_total_crop_residue'))
  totalCropResiduePercentage?: string;
}

export class DifferentFields {
  @serializable(object(SoilDetails))
  soil?: SoilDetails;

  @serializable(alias('land_management_changes', list(object(LandChanges))))
  landManagementChanges?: LandChanges[];

  @serializable(alias('land_use_changes', list(object(LandChanges))))
  landUseChanges?: LandChanges[];

  @serializable
  comments?: string;

  @serializable(alias('harvest_year'))
  harvestYear?: number;

  @serializable(alias('total_crop_residue'))
  totalCropResidue?: string;

  @serializable(alias('crop_residues', list(object(CropResidue))))
  cropResidues?: CropResidue[];
}

export class FieldDetails {
  @serializable(object(DifferentFields))
  commodity?: DifferentFields;
}

export class Stage4MetaData {
  @serializable
  label?: string;

  @serializable
  from?: string;

  @serializable
  to?: string;
}
